(function(){
function init(){
  var canvas=document.getElementById('urc-lens');
  if(!canvas)return;
  var x=canvas.getContext('2d'),dp=window.devicePixelRatio||1,SZ=310,tick=0;
  canvas.width=SZ*dp;canvas.height=SZ*dp;x.scale(dp,dp);
  var W=SZ,H=SZ,cx=155,cy=155,R=135;
  var step=1,visionPicked='',lensColor='grey',sunPct=0;
  var T={sv:0,prog:0,nonrx:0,read:0,screen:0,blue:0,adapt:0,progE:0,progP:0,slim:0,crown:0};
  var C={sv:0,prog:0,nonrx:0,read:0,screen:0,blue:0,adapt:0,progE:0,progP:0,slim:0,crown:0};
  var CM={
    grey:  {r1:185,g1:185,b1:190,r2:15,g2:15,b2:18},
    brown: {r1:175,g1:115,b1:65,r2:14,g2:8,b2:3},
    blue:  {r1:115,g1:165,b1:225,r2:5,g2:12,b2:30},
    green: {r1:118,g1:190,b1:138,r2:4,g2:18,b2:8},
    purple:{r1:178,g1:125,b1:218,r2:12,g2:5,b2:24},
    pink:  {r1:230,g1:148,b1:190,r2:22,g2:5,b2:14}
  };
  var DESCS={
    sv:'Ideal if you are under 40 or only need correction for one distance. One sharp focal point — the most common and affordable choice.',
    prog:'Ideal for adults 40+ who need help with near and far. No-line bifocals with smooth Distance, Intermediate and Reading zones.',
    nonrx:'No vision correction. Perfect for fashion, UV protection and premium coatings. All lens benefits included.',
    read:'Full-lens magnification for close-up tasks. Great for presbyopia — age-related near-vision loss common after 40.',
    std:'Included with every frame. Crystal-clear optics, scratch-resistant and anti-reflective coating, 100% UV protection.',
    screen:'All Standard benefits plus a near-zone boost that relieves screen fatigue. Ideal if you spend hours on screens daily.',
    clear:'Included at no extra cost. Scratch-resistant, anti-reflective and 100% UV. Clean and clear from day one.',
    adapt:'Clear indoors, automatically darkens in sunlight. Includes Blue Light Filter. One lens for every environment.',
    std_mat:'Polycarbonate — lightweight, impact-resistant and durable. Ideal for everyday use and prescriptions up to +/-3.00.',
    slim:'30% thinner and lighter than standard. High-index material that looks great in the frame. Best for prescriptions +/-4.00 and above.',
    shield:'Hydrophobic coating repels water, oil and fingerprints. Lenses stay cleaner and clearer all day with less wiping.',
    skip:'Your lenses already include premium anti-reflective and scratch-resistant coating. This extra coating is optional.',
    ess:'Smooth progression between Distance, Intermediate and Reading zones. Great for everyday use and first-time wearers.',
    pre:'Wider distortion-free corridor and comfortable peripheral vision. Best for strong prescriptions or those new to progressives.',
    blue:'Filters high-energy blue light from screens and devices. Includes clear lenses with full anti-reflective and UV protection.'
  };
  function lerp(a,b,f){return Math.round(a+(b-a)*f);}
  function fill(s){x.fillStyle=s;x.fillRect(0,0,W,H);}
  function smooth(){Object.keys(T).forEach(function(k){C[k]+=(T[k]-C[k])*0.06;});}

  var _labelVer=0;
  function animEl(el,fn){
    if(!el)return;
    el.style.transition='none';el.style.opacity='0';el.style.transform='translateY(5px)';
    fn();
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      el.style.transition='opacity 0.28s ease,transform 0.28s ease';
      el.style.opacity='1';el.style.transform='translateY(0)';
    });});
  }
  function setLabel(title,sub,descKey){
    _labelVer++;var ver=_labelVer;
    var e1=document.getElementById('urc-stage-lbl');
    var e2=document.getElementById('urc-stage-sub');
    var e3=document.getElementById('urc-stage-desc');
    animEl(e1,function(){if(e1)e1.textContent=title;});
    if(e2){
      if(sub){animEl(e2,function(){e2.textContent=sub;e2.style.display='block';});}
      else{e2.style.opacity='0';e2.textContent='';}
    }
    if(e3){
      if(descKey&&DESCS[descKey]){
        animEl(e3,function(){e3.textContent=DESCS[descKey];e3.style.display='block';});
      } else {
        e3.style.transition='opacity 0.18s';e3.style.opacity='0';
        setTimeout(function(){if(_labelVer===ver){var e=document.getElementById('urc-stage-desc');if(e)e.style.display='none';}},200);
      }
    }
  }

  function buildStep2Label(lastKey){
    var parts=[];
    if(T.screen)parts.push('Screen Shield');
    if(T.progE)parts.push('Progressive Essential');
    if(T.progP)parts.push('Progressive Premium');
    if(T.blue&&!T.adapt)parts.push('Blue Light Filter');
    if(T.adapt)parts.push('Light Adaptive');
    if(T.slim)parts.push('Slim Lenses');
    if(T.crown)parts.push('Crown Shield');
    var title=parts.length===0?'Standard Clear':parts.length===1?parts[0]:parts.length+' upgrades active';
    var sub=parts.length>1?parts.join(' \xb7 '):'';
    setLabel(title,sub,lastKey||null);
  }

  window.URC_LENS={
    setVision:function(v){
      visionPicked=v;
      var N={sv:'Single Vision',prog:'Progressive',nonrx:'Non-Prescription',read:'Reading'};
      Object.keys(T).forEach(function(k){if(k==='sv'||k==='prog'||k==='nonrx'||k==='read')T[k]=0;});
      if(v)T[v]=1;
      setLabel(N[v]||'Select your vision type','',v);
    },
    goStep2:function(){
      step=2;
      var rh=document.getElementById('urc-rx-hint');if(rh)rh.remove();
      T.sv=0;T.prog=0;T.nonrx=0;T.read=0;
      T.screen=0;T.blue=0;T.adapt=0;T.progE=0;T.progP=0;T.slim=0;T.crown=0;
      // Sync pre-selected defaults — animations + single welcome desc
      setTimeout(function(){
        if(!window.S)return;
        // Set animation layers silently (without updating label each time)
        if(S.power==='screen'){T.screen=1;}
        if(S.ltype==='blue'){T.blue=1;}
        if(S.ltype==='adapt'){
          T.blue=1;T.adapt=1;
          setTimeout(function(){
            // Inject sun-row if not already there
            if(!document.getElementById('urc-sun-row')){
              var w=document.getElementById('mcolors');
              if(w){
                var sr=document.createElement('div');sr.id='urc-sun-row';
                sr.style.cssText='display:flex;align-items:center;gap:10px;margin-top:8px;padding:8px 12px;background:rgba(201,168,76,0.04);border:1px solid rgba(201,168,76,0.12);border-radius:10px;';
                sr.innerHTML='<span style="font-size:10px;color:rgba(201,168,76,0.5);">Sun intensity</span><input type="range" id="urc-sun" min="0" max="100" value="0" step="1" style="flex:1;accent-color:#C9A84C;"><span id="urc-sun-val" style="font-size:10px;color:#C9A84C;font-weight:700;">0%</span>';
                w.appendChild(sr);
                var si=document.getElementById('urc-sun');
                if(si) si.oninput=function(){var v=parseInt(this.value);var sv=document.getElementById('urc-sun-val');if(sv)sv.textContent=v+'%';URC_LENS.setSun(v);};
              }
            }
          },200);
        }
        if(S.mat==='slim'){T.slim=1;}
        if(S.coat==='shield'){T.crown=1;}
        if(S.prog==='ess'){T.progE=1;}
        if(S.prog==='pre'){T.progP=1;}
        if(window.S&&S.vision==='prog'&&S.prog==='ess'){
          document.querySelectorAll('#g-prog .mc').forEach(function(cd){
            var oc=cd.getAttribute('onclick')||'';
            cd.classList.toggle('sel',oc.indexOf("'ess'")!==-1);
            var pt=cd.querySelector('.mc-p');
            if(!pt) return;
            if(oc.indexOf("'ess'")!==-1) pt.textContent='Included';
            else if(oc.indexOf("'pre'")!==-1) pt.textContent='+$40 upgrade';
          });
          if(window.ui) window.ui();
        }
        // Show a single meaningful description based on most important selection
        // Priority: prog > ltype upgrade > power upgrade > mat > base
        var descKey='std';
        if(S.prog)descKey=S.prog;
        else if(S.ltype&&S.ltype!=='clear')descKey=S.ltype;
        else if(S.power&&S.power!=='std')descKey=S.power;
        else if(S.mat&&S.mat!=='std')descKey=S.mat;
        else if(S.coat&&S.coat!=='skip')descKey='shield';
        buildStep2Label(descKey);
      },60);
    },
    goStep1:function(){
      step=1;
      var sh=document.getElementById('urc-sh');if(sh)sh.remove();
      var rh=document.getElementById('urc-rx-hint');if(rh)rh.remove();
      T.screen=0;T.blue=0;T.adapt=0;T.progE=0;T.progP=0;T.slim=0;T.crown=0;
      T.sv=0;T.prog=0;T.nonrx=0;T.read=0;
      if(visionPicked)T[visionPicked]=1;
      var N={sv:'Single Vision',prog:'Progressive',nonrx:'Non-Prescription',read:'Reading'};
      setLabel(N[visionPicked]||'Select your vision type','',visionPicked||null);
    },
    onPick:function(key,val){
      if(step!==2)return;
      if(key==='power'){T.screen=(val==='screen')?1:0;buildStep2Label(val==='screen'?'screen':'std');}
      if(key==='prog'){T.progE=(val==='ess')?1:0;T.progP=(val==='pre')?1:0;buildStep2Label(val);}
      if(key==='ltype'){
        T.blue=0;T.adapt=0;
        if(val==='blue')T.blue=1;
        if(val==='adapt'){T.blue=1;T.adapt=1;}
        // Hide sun row if not adaptive
        if(val!=='adapt'){
          var sr=document.getElementById('urc-sun-row');
          if(sr){sr.style.transition='opacity 0.25s';sr.style.opacity='0';setTimeout(function(){var s=document.getElementById('urc-sun-row');if(s)s.style.display='none';},260);}
          sunPct=0;
          var si=document.getElementById('urc-sun');if(si)si.value=0;
          var sv=document.getElementById('urc-sun-val');if(sv)sv.textContent='0%';
        } else {
          var sr2=document.getElementById('urc-sun-row');
          if(!sr2){
            var w2=document.getElementById('mcolors');
            if(w2){
              sr2=document.createElement('div');sr2.id='urc-sun-row';
              sr2.style.cssText='display:flex;align-items:center;gap:10px;margin-top:8px;padding:8px 12px;background:rgba(201,168,76,0.04);border:1px solid rgba(201,168,76,0.12);border-radius:10px;opacity:0;';
              sr2.innerHTML='<span style="font-size:10px;color:rgba(201,168,76,0.5);">Sun intensity</span><input type="range" id="urc-sun" min="0" max="100" value="0" step="1" style="flex:1;accent-color:#C9A84C;"><span id="urc-sun-val" style="font-size:10px;color:#C9A84C;font-weight:700;">0%</span>';
              w2.appendChild(sr2);
              var si2=document.getElementById('urc-sun');
              if(si2) si2.oninput=function(){var v=parseInt(this.value);var sv=document.getElementById('urc-sun-val');if(sv)sv.textContent=v+'%';URC_LENS.setSun(v);};
            }
          }
          if(sr2){sr2.style.display='flex';requestAnimationFrame(function(){sr2.style.opacity='1';});}
        }
        buildStep2Label(val);
      }
      if(key==='mat'){T.slim=(val==='slim')?1:0;buildStep2Label(val==='slim'?'slim':'std_mat');}
      if(key==='coat'){T.crown=(val==='shield')?1:0;buildStep2Label(val==='shield'?'shield':'skip');}
    },
    setColor:function(c){lensColor=c;},
    setSun:function(v){sunPct=v;},
    reset:function(){
      step=1;visionPicked='';lensColor='grey';sunPct=0;
      var sh=document.getElementById('urc-sh');if(sh)sh.remove();
      var rh=document.getElementById('urc-rx-hint');if(rh)rh.remove();
      Object.keys(T).forEach(function(k){T[k]=0;});
      setLabel('Select your vision type','',null);
    }
  };

  function drawSV(op){
    if(op<0.01)return;x.save();
    var bg=x.createRadialGradient(cx,cy,0,cx,cy,R);bg.addColorStop(0,'rgba(220,235,255,'+(0.18*op)+')');bg.addColorStop(1,'rgba(100,160,255,'+(0.04*op)+')');fill(bg);
    var pu=0.82+0.18*Math.sin(tick*0.04);
    x.beginPath();x.arc(cx,cy,R*0.28*pu,0,Math.PI*2);x.strokeStyle='rgba(201,168,76,'+(0.7*op)+')';x.lineWidth=2;x.stroke();
    x.beginPath();x.arc(cx,cy,R*0.06,0,Math.PI*2);x.fillStyle='rgba(201,168,76,'+(0.9*op)+')';x.fill();
    for(var i=0;i<8;i++){var a=i*Math.PI/4+tick*0.008;x.beginPath();x.moveTo(cx+Math.cos(a)*R*0.32*pu,cy+Math.sin(a)*R*0.32*pu);x.lineTo(cx+Math.cos(a)*R*0.52*pu,cy+Math.sin(a)*R*0.52*pu);x.strokeStyle='rgba(201,168,76,'+(0.18*op)+')';x.lineWidth=1;x.stroke();}
    x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(201,168,76,'+(0.45*op)+')';x.fillText('SINGLE FOCAL POINT',cx,cy+R*0.88);x.restore();
  }
  function drawProg(op){
    if(op<0.01)return;x.save();
    var zg=x.createLinearGradient(cx,cy-R,cx,cy+R);zg.addColorStop(0,'rgba(100,160,255,'+(0.22*op)+')');zg.addColorStop(0.5,'rgba(255,255,255,'+(0.02*op)+')');zg.addColorStop(1,'rgba(255,180,60,'+(0.22*op)+')');fill(zg);
    var cW=R*0.52+R*0.06*Math.sin(tick*0.025);
    x.strokeStyle='rgba(201,168,76,'+(0.28*op)+')';x.lineWidth=0.8;x.setLineDash([5,6]);
    x.beginPath();x.moveTo(cx-cW/2,cy-R*0.85);x.lineTo(cx-cW/2*0.55,cy+R*0.85);x.stroke();
    x.beginPath();x.moveTo(cx+cW/2,cy-R*0.85);x.lineTo(cx+cW/2*0.55,cy+R*0.85);x.stroke();
    x.setLineDash([]);x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';
    x.fillStyle='rgba(140,185,255,'+(0.55*op)+')';x.fillText('DISTANCE',cx,cy-R*0.55);
    x.fillStyle='rgba(255,255,255,'+(0.55*op)+')';x.fillText('INTERMEDIATE',cx,cy);
    x.fillStyle='rgba(255,200,80,'+(0.55*op)+')';x.fillText('READING',cx,cy+R*0.50);x.restore();
  }
  function drawNonRx(op){
    if(op<0.01)return;x.save();
    var bg=x.createRadialGradient(cx-R*.2,cy-R*.2,0,cx,cy,R);bg.addColorStop(0,'rgba(255,255,255,'+(0.12*op)+')');bg.addColorStop(1,'rgba(201,168,76,'+(0.04*op)+')');fill(bg);
    var sp=0.88+0.12*Math.sin(tick*0.035),sw=R*0.42*sp,sh=R*0.52*sp;
    x.beginPath();x.moveTo(cx,cy-sh);x.bezierCurveTo(cx+sw,cy-sh,cx+sw,cy,cx,cy+sh);x.bezierCurveTo(cx-sw,cy,cx-sw,cy-sh,cx,cy-sh);
    x.strokeStyle='rgba(201,168,76,'+(0.65*op)+')';x.lineWidth=2;x.stroke();
    x.beginPath();x.moveTo(cx-sw*0.28,cy);x.lineTo(cx-sw*0.06,cy+sh*0.22);x.lineTo(cx+sw*0.3,cy-sh*0.22);
    x.strokeStyle='rgba(201,168,76,'+(0.9*op)+')';x.lineWidth=2.5;x.lineCap='round';x.lineJoin='round';x.stroke();
    x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(201,168,76,'+(0.45*op)+')';x.fillText('UV + BLUE LIGHT PROTECTED',cx,cy+R*0.88);x.restore();
  }
  function drawRead(op){
    if(op<0.01)return;x.save();
    var rbg=x.createRadialGradient(cx,cy,R*0.05,cx,cy,R);rbg.addColorStop(0,'rgba(255,240,160,'+(0.22*op)+')');rbg.addColorStop(1,'rgba(200,140,30,'+(0.08*op)+')');fill(rbg);
    for(var ri=0;ri<5;ri++){var ph=(tick*0.018+ri*0.2)%1;x.beginPath();x.arc(cx,cy,R*0.12+ph*R*0.82,0,Math.PI*2);x.strokeStyle='rgba(255,210,80,'+(Math.sin(ph*Math.PI)*0.28*op)+')';x.lineWidth=1.4;x.stroke();}
    var lws=[0.72,0.58,0.68,0.52,0.62,0.46];
    for(var li=0;li<6;li++){var lw=R*lws[li],ly=cy-R*0.45+li*R*0.19,lsx=cx-R+(((tick*0.7+li*28)%(R*2.4)));var lg=x.createLinearGradient(lsx-R*0.18,0,lsx+R*0.18,0);lg.addColorStop(0,'rgba(255,245,180,0)');lg.addColorStop(0.5,'rgba(255,245,180,'+(0.55*op)+')');lg.addColorStop(1,'rgba(255,245,180,0)');x.fillStyle=lg;x.fillRect(cx-lw,ly-5,lw*2,9);x.beginPath();x.moveTo(cx-lw,ly);x.lineTo(cx+lw,ly);x.strokeStyle='rgba(255,220,100,'+(0.32*op)+')';x.lineWidth=1.4;x.stroke();}
    x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(255,210,80,'+(0.55*op)+')';x.fillText('FULL LENS MAGNIFICATION',cx,cy+R*0.88);x.restore();
  }
  function drawScreen(op){
    if(op<0.01)return;fill('rgba(40,150,75,'+(0.05*op)+')');
    var sy=cy-R+((tick*0.28)%(R*2));var scg=x.createLinearGradient(0,sy-11,0,sy+11);scg.addColorStop(0,'rgba(55,195,90,0)');scg.addColorStop(0.5,'rgba(55,195,90,'+(0.11*op)+')');scg.addColorStop(1,'rgba(55,195,90,0)');fill(scg);
  }
  function drawBlue(op){
    if(op<0.01)return;fill('rgba(20,75,210,'+(0.07*op)+')');
    var bx=cx-R+((Math.sin(tick*0.018)*0.5+0.5))*R*2;var bg3=x.createLinearGradient(bx-R*0.26,0,bx+R*0.26,0);bg3.addColorStop(0,'rgba(30,110,240,0)');bg3.addColorStop(0.5,'rgba(30,110,240,'+(0.20*op)+')');bg3.addColorStop(1,'rgba(30,110,240,0)');fill(bg3);
    var bx2=cx-R+((Math.sin(tick*0.011+2.1)*0.5+0.5))*R*2;var bg4=x.createLinearGradient(bx2-R*0.20,0,bx2+R*0.20,0);bg4.addColorStop(0,'rgba(15,90,220,0)');bg4.addColorStop(0.5,'rgba(15,90,220,'+(0.10*op)+')');bg4.addColorStop(1,'rgba(15,90,220,0)');fill(bg4);
  }
  function drawAdapt(op){
    if(op<0.01)return;var cc=CM[lensColor]||CM.grey;var sf=sunPct/100;
    var rr=lerp(cc.r1,cc.r2,sf),gg=lerp(cc.g1,cc.g2,sf),bb=lerp(cc.b1,cc.b2,sf);
    fill('rgba('+rr+','+gg+','+bb+','+((lerp(18,85,sf)/100)*op)+')');
    var vg=x.createRadialGradient(cx,cy,R*0.08,cx,cy,R);vg.addColorStop(0,'rgba('+rr+','+gg+','+bb+',0)');vg.addColorStop(1,'rgba('+Math.max(0,rr-55)+','+Math.max(0,gg-55)+','+Math.max(0,bb-55)+','+(0.42*op)+')');fill(vg);
    if(sf>0.35){var gl=x.createRadialGradient(cx,cy-R*1.1,0,cx,cy-R*0.1,R*0.78);gl.addColorStop(0,'rgba(255,242,180,'+(0.20*op*(sf-0.35)/0.65)+')');gl.addColorStop(1,'rgba(255,242,180,0)');fill(gl);}
    x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(255,255,255,'+(0.50*op)+')';x.fillText(sunPct>0?sunPct+'% activated':'Indoor',cx,cy+R*0.75);
  }
  function drawProgEss(op){
    if(op<0.01)return;x.save();
    var zg=x.createLinearGradient(cx,cy-R,cx,cy+R);zg.addColorStop(0,'rgba(90,150,255,'+(0.06*op)+')');zg.addColorStop(0.32,'rgba(90,150,255,'+(0.02*op)+')');zg.addColorStop(0.5,'rgba(255,255,255,0)');zg.addColorStop(0.68,'rgba(255,210,80,'+(0.02*op)+')');zg.addColorStop(1,'rgba(255,165,40,'+(0.06*op)+')');fill(zg);
    var cW=R*0.30+R*0.03*Math.sin(tick*0.020);
    x.strokeStyle='rgba(201,168,76,'+(0.22*op)+')';x.lineWidth=0.8;x.setLineDash([4,5]);
    x.beginPath();x.moveTo(cx-cW/2,cy-R*0.88);x.lineTo(cx-cW/2*0.60,cy+R*0.88);x.stroke();
    x.beginPath();x.moveTo(cx+cW/2,cy-R*0.88);x.lineTo(cx+cW/2*0.60,cy+R*0.88);x.stroke();
    x.setLineDash([]);x.fillStyle='rgba(255,255,255,'+(0.03*op)+')';x.fillRect(0,0,cx-cW/2-4,H);x.fillRect(cx+cW/2+4,0,W,H);
    x.strokeStyle='rgba(255,255,255,'+(0.08*op)+')';x.lineWidth=0.5;x.beginPath();x.moveTo(cx-R*0.88,cy-R*0.20);x.lineTo(cx+R*0.88,cy-R*0.20);x.stroke();x.beginPath();x.moveTo(cx-R*0.82,cy+R*0.20);x.lineTo(cx+R*0.82,cy+R*0.20);x.stroke();
    x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(140,190,255,'+(0.60*op)+')';x.fillText('DISTANCE',cx,cy-R*0.52);x.fillStyle='rgba(220,220,220,'+(0.45*op)+')';x.fillText('INTERMEDIATE',cx,cy);x.fillStyle='rgba(255,205,80,'+(0.60*op)+')';x.fillText('READING',cx,cy+R*0.56);x.restore();
  }
  function drawProgPre(op){
    if(op<0.01)return;x.save();
    var zg=x.createLinearGradient(cx,cy-R,cx,cy+R);zg.addColorStop(0,'rgba(90,150,255,'+(0.12*op)+')');zg.addColorStop(0.28,'rgba(90,150,255,'+(0.03*op)+')');zg.addColorStop(0.5,'rgba(255,255,255,0)');zg.addColorStop(0.72,'rgba(255,210,80,'+(0.03*op)+')');zg.addColorStop(1,'rgba(255,165,40,'+(0.12*op)+')');fill(zg);
    var cW=R*0.80+R*0.04*Math.sin(tick*0.020);
    x.strokeStyle='rgba(201,168,76,'+(0.28*op)+')';x.lineWidth=0.9;x.setLineDash([5,6]);
    x.beginPath();x.moveTo(cx-cW/2,cy-R*0.88);x.lineTo(cx-cW/2*0.70,cy+R*0.88);x.stroke();x.beginPath();x.moveTo(cx+cW/2,cy-R*0.88);x.lineTo(cx+cW/2*0.70,cy+R*0.88);x.stroke();x.setLineDash([]);
    x.strokeStyle='rgba(255,255,255,'+(0.07*op)+')';x.lineWidth=0.5;x.beginPath();x.moveTo(cx-R*0.88,cy-R*0.20);x.lineTo(cx+R*0.88,cy-R*0.20);x.stroke();x.beginPath();x.moveTo(cx-R*0.82,cy+R*0.20);x.lineTo(cx+R*0.82,cy+R*0.20);x.stroke();
    x.font='bold 10px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(140,190,255,'+(0.68*op)+')';x.fillText('DISTANCE',cx,cy-R*0.52);x.fillStyle='rgba(255,255,255,'+(0.50*op)+')';x.fillText('INTERMEDIATE',cx,cy);x.fillStyle='rgba(255,205,80,'+(0.68*op)+')';x.fillText('READING',cx,cy+R*0.56);
    x.fillStyle='rgba(201,168,76,'+(0.35*op)+')';[[cx-cW/2-2,cy],[cx+cW/2+2,cy],[cx,cy-R*0.20],[cx,cy+R*0.20]].forEach(function(p){x.beginPath();x.arc(p[0],p[1],1.3,0,Math.PI*2);x.fill();});x.restore();
  }
  function drawCrown(op){
    if(op<0.01)return;
    var ra=tick*0.014;var rg=x.createLinearGradient(cx+Math.cos(ra)*R,cy+Math.sin(ra)*R,cx-Math.cos(ra)*R,cy-Math.sin(ra)*R);
    rg.addColorStop(0,'rgba(255,50,120,'+(0.09*op)+')');rg.addColorStop(0.33,'rgba(255,180,0,'+(0.08*op)+')');rg.addColorStop(0.66,'rgba(0,190,255,'+(0.09*op)+')');rg.addColorStop(1,'rgba(110,0,255,'+(0.08*op)+')');fill(rg);
    [{x:cx-R*.13,y:cy-R*.09,r:R*.072},{x:cx+R*.26,y:cy+R*.18,r:R*.056},{x:cx-R*.35,y:cy+R*.22,r:R*.047},{x:cx+R*.07,y:cy-R*.36,r:R*.060}].forEach(function(d){
      var ddx=d.x-cx,ddy=d.y-cy;if(Math.sqrt(ddx*ddx+ddy*ddy)+d.r>R*.92)return;
      x.save();x.globalAlpha=op;x.beginPath();x.arc(d.x,d.y,d.r,0,Math.PI*2);x.clip();
      var dg=x.createRadialGradient(d.x-d.r*.3,d.y-d.r*.34,0,d.x,d.y,d.r);dg.addColorStop(0,'rgba(255,255,255,0.62)');dg.addColorStop(1,'rgba(100,150,255,0.04)');x.fillStyle=dg;x.fillRect(d.x-d.r,d.y-d.r,d.r*2,d.r*2);x.restore();
      x.globalAlpha=op;x.beginPath();x.arc(d.x,d.y,d.r,0,Math.PI*2);x.strokeStyle='rgba(200,225,255,0.48)';x.lineWidth=0.7;x.stroke();x.globalAlpha=1;
    });
  }

  function draw(){
    tick++;smooth();x.clearRect(0,0,W,H);x.save();x.beginPath();x.arc(cx,cy,R,0,Math.PI*2);x.clip();
    var bg=x.createRadialGradient(cx-R*.28,cy-R*.28,0,cx,cy,R);bg.addColorStop(0,'rgba(255,255,255,0.11)');bg.addColorStop(1,'rgba(201,168,76,0.03)');fill(bg);
    var sx=cx-R+((Math.sin(tick*0.015)*0.5+0.5))*R*2;var sg=x.createLinearGradient(sx-R*0.18,0,sx+R*0.18,0);sg.addColorStop(0,'rgba(255,255,255,0)');sg.addColorStop(0.5,'rgba(255,255,255,0.08)');sg.addColorStop(1,'rgba(255,255,255,0)');fill(sg);
    var ha=tick*0.010;var hg=x.createLinearGradient(cx+Math.cos(ha)*R,cy+Math.sin(ha)*R,cx-Math.cos(ha)*R,cy-Math.sin(ha)*R);hg.addColorStop(0,'rgba(50,170,70,0)');hg.addColorStop(0.5,'rgba(60,185,80,0.040)');hg.addColorStop(1,'rgba(50,170,70,0)');fill(hg);
    if(step===1){
      var anyV=C.sv+C.prog+C.nonrx+C.read;
      if(anyV<0.05){var idle=0.5+0.5*Math.sin(tick*0.022);var ig=x.createLinearGradient(cx-R+((tick*0.4)%(R*2.2)),0,cx-R+((tick*0.4)%(R*2.2))+R*0.6,H);ig.addColorStop(0,'rgba(255,255,255,0)');ig.addColorStop(0.5,'rgba(255,255,255,'+(0.06*idle)+')');ig.addColorStop(1,'rgba(255,255,255,0)');fill(ig);}
      drawSV(C.sv);drawProg(C.prog);drawNonRx(C.nonrx);drawRead(C.read);
    } else {
      drawScreen(C.screen);drawBlue(C.blue);drawAdapt(C.adapt);drawProgEss(C.progE);drawProgPre(C.progP);drawCrown(C.crown);
    }
    var hl=x.createRadialGradient(cx-R*.34,cy-R*.38,0,cx-45,cy-45,R*.52);hl.addColorStop(0,'rgba(255,255,255,0.15)');hl.addColorStop(1,'rgba(255,255,255,0)');fill(hl);
    x.font='9px DM Sans,sans-serif';x.textAlign='center';x.fillStyle='rgba(201,168,76,0.11)';x.fillText('URCROWN OPTICS',cx,cy+R*0.93);x.restore();
    var rimW=step===2?lerp(32,9,C.slim)/10:1.8;rimW+=C.crown*0.4;
    x.beginPath();x.arc(cx,cy,R,0,Math.PI*2);x.strokeStyle='rgba(201,168,76,'+(0.34+0.22*C.crown)+')';x.lineWidth=rimW;x.stroke();
    if(C.slim>0.01){x.beginPath();x.arc(cx,cy,R-3,0,Math.PI*2);x.strokeStyle='rgba(201,168,76,'+(0.15*C.slim)+')';x.lineWidth=0.5;x.stroke();}
    requestAnimationFrame(draw);
  }
  draw();

  function addScrollHint(){
    if(step!==2)return;
    var ms=document.getElementById('mscroll');if(!ms)return;
    var ex=document.getElementById('urc-sh');if(ex)ex.remove();
    var sh=document.createElement('div');sh.id='urc-sh';
    sh.style.cssText='position:sticky;bottom:8px;text-align:center;pointer-events:none;transition:opacity 0.4s;margin-bottom:2px;';
    sh.innerHTML='<div style="display:inline-flex;align-items:center;gap:5px;background:rgba(13,13,13,0.92);border:1px solid rgba(201,168,76,0.28);border-radius:14px;padding:4px 11px;"><svg width="11" height="11" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M5 11l5 5 5-5" stroke="#C9A84C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-size:8px;color:#C9A84C;letter-spacing:0.12em;font-weight:700;">MORE OPTIONS</span></div>';
    if(!document.getElementById('urc-bs')){var st=document.createElement('style');st.id='urc-bs';st.textContent='#urc-sh>div{animation:urcB 2s ease-in-out infinite}@keyframes urcB{0%,100%{transform:translateY(0)}50%{transform:translateY(3px)}}';document.head.appendChild(st);}
    ms.appendChild(sh);
    ms.addEventListener('scroll',function(){
      if(step!==2){var s=document.getElementById('urc-sh');if(s)s.remove();return;}
      sh.style.opacity=(ms.scrollTop+ms.clientHeight>=ms.scrollHeight-24)?'0':'1';
    });
  }

  var _step=1;
  var _iv=setInterval(function(){
    if(!window.URC)return;clearInterval(_iv);
    var _pick=URC.pick.bind(URC);
    URC.pick=function(key,val,card){
      _pick(key,val,card);
      if(key==='vision'){
        URC_LENS.setVision(val);
        if(val==='prog'&&window.S&&!S.prog){
          S.prog='ess';
        }
        if(window.ui) window.ui();
      } else {
        URC_LENS.onPick(key,val);
      }
    };
    var _next=URC.next.bind(URC);
    URC.next=function(){
      var was=_step;_next();
      var p2=document.getElementById('p2'),p3=document.getElementById('p3');
      _step=p3&&p3.classList.contains('on')?3:p2&&p2.classList.contains('on')?2:1;
      if(was===1&&_step===2){URC_LENS.goStep2();setTimeout(addScrollHint,500);}
      if(_step===3){
        var sh=document.getElementById('urc-sh');if(sh)sh.remove();
        var lc=document.getElementById('mrxc-later');
        if(lc&&window.S&&!S.rxM) lc.click();
        // Show summary + motivational message
        setTimeout(function(){
          if(!window.S)return;
          var parts=[];
          var vn={sv:'Single Vision',prog:'Progressive',nonrx:'Non-Prescription',read:'Reading'};
          if(S.vision)parts.push(vn[S.vision]||S.vision);
          if(S.power==='screen')parts.push('Screen Shield');
          else parts.push('Standard Clear');
          if(S.prog){var pn={ess:'Progressive Essential',pre:'Progressive Premium'};parts.push(pn[S.prog]||S.prog);}
          if(S.ltype==='adapt')parts.push('Light Adaptive');
          else if(S.ltype==='blue')parts.push('Blue Light Filter');
          else parts.push('Clear Lenses');
          if(S.mat==='slim')parts.push('Slim Lenses');
          else parts.push('Standard Material');
          if(S.coat==='shield')parts.push('Crown Shield Coating');
          else parts.push('Standard Coating');
          var upgrades=parts.length-1;
          var msgs;
          if(upgrades>=4)msgs=['You are going to turn heads everywhere you go.','People will notice the difference. Bold choice.','Full upgrade — these frames will define your look.'];
          else if(upgrades>=2)msgs=['Sharp choice — you are going to love wearing these.','Everyone is going to ask where you got those.','Great selection — style and function in one pair.'];
          else msgs=['Classic and clean — effortless style every day.','Simple, clear and always on point.','Timeless — these will go with everything you wear.'];
          var msg=msgs[Math.floor(Math.random()*msgs.length)];
          var sub=parts.join(' · ');
          var e1=document.getElementById('urc-stage-lbl');
          var e2=document.getElementById('urc-stage-sub');
          var e3=document.getElementById('urc-stage-desc');
          if(e1){e1.style.transition='none';e1.style.opacity='0';e1.style.transform='translateY(5px)';e1.textContent=msg;requestAnimationFrame(function(){requestAnimationFrame(function(){e1.style.transition='opacity 0.3s ease,transform 0.3s ease';e1.style.opacity='1';e1.style.transform='translateY(0)';});});}
          if(e2&&sub){e2.textContent=sub;e2.style.display='block';e2.style.opacity='0.7';}
          if(e3){e3.style.display='none';e3.textContent='';}
        },100);
        setTimeout(function(){
          var ms=document.getElementById('mscroll');if(!ms)return;
          if(ms.scrollHeight<=ms.clientHeight+10)return;
          var ex=document.getElementById('urc-rx-hint');if(ex)ex.remove();
          var hint=document.createElement('div');hint.id='urc-rx-hint';
          hint.style.cssText='position:sticky;bottom:8px;text-align:center;pointer-events:none;opacity:0;transition:opacity 0.35s;margin-bottom:2px;';
          hint.innerHTML='<div style="display:inline-flex;align-items:center;gap:5px;background:rgba(13,13,13,0.92);border:1px solid rgba(201,168,76,0.28);border-radius:14px;padding:4px 11px;"><svg width="11" height="11" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M5 11l5 5 5-5" stroke="#C9A84C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-size:8px;color:#C9A84C;letter-spacing:0.12em;font-weight:700;">MORE OPTIONS</span></div>';
          ms.appendChild(hint);
          requestAnimationFrame(function(){requestAnimationFrame(function(){hint.style.opacity='1';});});
          ms.addEventListener('scroll',function s3(){
            var h=document.getElementById('urc-rx-hint');if(!h){ms.removeEventListener('scroll',s3);return;}
            h.style.opacity=(ms.scrollTop+ms.clientHeight>=ms.scrollHeight-20)?'0':'1';
          });
        },300);
      }
    };
    var _back=URC.back.bind(URC);
    URC.back=function(){
      _back();
      var p1=document.getElementById('p1'),p2=document.getElementById('p2');
      _step=p1&&p1.classList.contains('on')?1:p2&&p2.classList.contains('on')?2:_step;
      if(_step===1)URC_LENS.goStep1();
      if(_step===2){
        // Remove read more, show more options again
        var rh=document.getElementById('urc-rx-hint');if(rh)rh.remove();
        setTimeout(addScrollHint,100);
      }
    };
    var _open=URC.open.bind(URC);
    URC.open=function(){
      _open();_step=1;
      // Full reset first
      URC_LENS.reset();
      // Then immediately set vision (S.vision already set to 'sv' by HTML open fn)
      var v=window.S&&S.vision?S.vision:'sv';
      URC_LENS.setVision(v);
      // Tablet fix: remove min-height so content scrolls inside modal
      if(window.innerWidth<=768){
        var ms=document.getElementById('mscroll');
        if(ms) ms.style.minHeight='0';
      }
    };
    // Patch pickRx — show READ MORE hint when Rx panel expands (step 3)
    function showRxHint(){
      // Hide step2 MORE OPTIONS hint
      var sh=document.getElementById('urc-sh');if(sh)sh.style.opacity='0';
      var ms=document.getElementById('mscroll');if(!ms)return;
      // Remove old rx hint with fade
      var ex=document.getElementById('urc-rx-hint');
      if(ex){ex.style.opacity='0';setTimeout(function(){var e=document.getElementById('urc-rx-hint');if(e)e.remove();showRxHintCreate();},250);}
      else{showRxHintCreate();}
    }
    function showRxHintCreate(){
      var ms=document.getElementById('mscroll');if(!ms)return;
      setTimeout(function(){
        if(ms.scrollHeight<=ms.clientHeight+10)return;
        var hint=document.createElement('div');hint.id='urc-rx-hint';
        hint.style.cssText='position:sticky;bottom:8px;text-align:center;pointer-events:none;opacity:0;transition:opacity 0.35s;margin-bottom:2px;';
        hint.innerHTML='<div style="display:inline-flex;align-items:center;gap:5px;background:rgba(13,13,13,0.92);border:1px solid rgba(201,168,76,0.28);border-radius:14px;padding:4px 11px;"><svg width="11" height="11" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M5 11l5 5 5-5" stroke="#C9A84C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-size:8px;color:#C9A84C;letter-spacing:0.12em;font-weight:700;">READ MORE</span></div>';
        ms.appendChild(hint);
        // Animate in
        requestAnimationFrame(function(){requestAnimationFrame(function(){hint.style.opacity='1';});});
        ms.addEventListener('scroll',function rh(){
          var h=document.getElementById('urc-rx-hint');if(!h){ms.removeEventListener('scroll',rh);return;}
          h.style.opacity=(ms.scrollTop+ms.clientHeight>=ms.scrollHeight-20)?'0':'1';
        });
      },150);
    }
    if(URC.pickRx){
      var _pickRx=URC.pickRx.bind(URC);
      URC.pickRx=function(m,card){
        _pickRx(m,card);
        showRxHint();
        // If Send Later: add cart note so Shopify Flow can detect it
        if(m==='later'||m==='doctor'){
          fetch('/cart/update.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({note:m==='later'?'rx-send-later':'rx-contact-doctor'})
          });
        }
      };
    }

    var _pickColor=URC.pickColor.bind(URC);
    URC.pickColor=function(cid,sw){
      _pickColor(cid,sw);URC_LENS.setColor(cid);
      if(!document.getElementById('urc-sun-row')){
        var w=document.getElementById('mcolors');if(!w)return;
        var sr=document.createElement('div');sr.id='urc-sun-row';
        sr.style.cssText='display:flex;align-items:center;gap:10px;margin-top:8px;padding:8px 12px;background:rgba(201,168,76,0.04);border:1px solid rgba(201,168,76,0.12);border-radius:10px;';
        sr.innerHTML='<span style="font-size:10px;color:rgba(201,168,76,0.5);">Sun intensity</span><input type="range" id="urc-sun" min="0" max="100" value="0" step="1" style="flex:1;accent-color:#C9A84C;"><span id="urc-sun-val" style="font-size:10px;color:#C9A84C;font-weight:700;">0%</span>';
        w.parentNode.insertBefore(sr,w.nextSibling);
        document.getElementById('urc-sun').oninput=function(){var v=parseInt(this.value);document.getElementById('urc-sun-val').textContent=v+'%';URC_LENS.setSun(v);};
      }
    };
  },100);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
else{init();}
})();

// Patch product page add-to-cart button for rx-lenses products
(function(){
  function patchProductBtn(){
    var btn=document.querySelector('button[name="add"]');
    if(!btn)return;
    btn.innerHTML='&#9819; Build Your Pair';
    btn.setAttribute('type','button');
    btn.style.animation='urc-pulse 3.5s ease-in-out infinite';
    btn.onclick=function(e){
      e.preventDefault();
      e.stopPropagation();
      if(window.URC)URC.open();
    };
    if(!document.getElementById('urc-btn-sub')){
      var sub=document.createElement('div');
      sub.id='urc-btn-sub';
      sub.style.cssText='text-align:center;font-size:11px;color:rgba(201,168,76,0.55);margin-top:5px;letter-spacing:0.04em;';
      sub.textContent='Frames + Lenses Included';
      btn.parentNode.insertBefore(sub,btn.nextSibling);
    }
  }
  function initBtn(){
    patchProductBtn();
    var form=document.querySelector('form[action="/cart/add"]');
    if(form){
      var obs=new MutationObserver(function(){
        var b=document.querySelector('button[name="add"]');
        if(b&&b.innerHTML.indexOf('Build')===-1) patchProductBtn();
      });
      obs.observe(form,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initBtn);
  } else {
    initBtn();
  }
})();

// Sync fixed bar image with main product image when variant changes
(function(){
  function resizeForBar(src){
    if(!src) return src;
    // Already has size suffix - replace it, otherwise add before extension
    if(src.indexOf('_100x100')!==-1) return src;
    return src.replace(/(_[0-9]+x[0-9]+[^.]*)?(\.[a-z]+)(\?|$)/i,'_100x100_crop_center$2$3');
  }
  function syncBarImg(src){
    var bar=document.querySelector('.urc-bar-img');
    if(bar&&src) bar.src=resizeForBar(src);
  }
  // Watch the main product image for src changes (Horizon swaps it on variant change)
  function watchMainImg(){
    // Horizon product image selectors
    var selectors=[
      '.product__media--featured img',
      '.product-single__photo img',
      '.product__media img',
      '[data-product-single-media-wrapper] img',
      '.featured-media img'
    ];
    var mainImg=null;
    for(var i=0;i<selectors.length;i++){
      mainImg=document.querySelector(selectors[i]);
      if(mainImg) break;
    }
    if(!mainImg) return;
    var obs=new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        if(m.type==='attributes'&&m.attributeName==='src'){
          syncBarImg(mainImg.src||mainImg.getAttribute('src'));
        }
      });
    });
    obs.observe(mainImg,{attributes:true,attributeFilter:['src']});
    // Also watch srcset changes
    var obs2=new MutationObserver(function(){
      var src=mainImg.getAttribute('src');
      if(src) syncBarImg(src);
    });
    obs2.observe(mainImg,{attributes:true,attributeFilter:['srcset']});
  }
  // Also listen for URL changes (Horizon updates ?variant= in URL)
  var lastVariant='';
  function checkVariantUrl(){
    var m=location.search.match(/variant=(\d+)/);
    var vid=m?m[1]:'';
    if(vid&&vid!==lastVariant){
      lastVariant=vid;
      // Find variant image from Shopify product JSON
      var jsonEl=document.getElementById('product-json')||document.querySelector('[data-product-json]');
      if(jsonEl){
        try{
          var data=JSON.parse(jsonEl.textContent||jsonEl.innerHTML);
          var variants=data.variants||[];
          for(var i=0;i<variants.length;i++){
            if(String(variants[i].id)===vid){
              var fi=variants[i].featured_image;
              if(fi&&fi.src) syncBarImg(fi.src);
              break;
            }
          }
        }catch(e){}
      }
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){
      watchMainImg();
      setInterval(checkVariantUrl,400);
    });
  } else {
    watchMainImg();
    setInterval(checkVariantUrl,400);
  }
})();

// Sync urc-bar-img with Horizon sticky button image on variant change
(function(){
  function syncBarImg(){
    var src=document.querySelector('.sticky-add-to-cart__image-img');
    var bar=document.querySelector('.urc-bar-img');
    if(!src||!bar) return;
    // Horizon uses ?width=120, resize to smaller for our 52px bar
    var newSrc=src.src.replace(/(\?|&)width=\d+/,'$1width=100');
    bar.src=newSrc;
  }
  // Watch Horizon's own sticky image - when it changes, copy to our bar
  function watchHorizonImg(){
    var horizonImg=document.querySelector('.sticky-add-to-cart__image-img');
    if(!horizonImg){setTimeout(watchHorizonImg,500);return;}
    new MutationObserver(function(){syncBarImg();})
      .observe(horizonImg,{attributes:true,attributeFilter:['src','srcset']});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',watchHorizonImg);
  } else {
    watchHorizonImg();
  }
})();
